/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { mixins, fonts } from '@blend/consumer-components';
import { mediaBreakpoints } from '../../common/responsive';

export const styles = {
  defaultTemplate: {
    ...mixins.margin(120, 'auto', 24),
    maxWidth: 520,
    [mediaBreakpoints.mobile]: {
      paddingTop: 24,
      ...mixins.margin(0, 'auto'),
      maxWidth: 342,
      display: 'block',
    },
  },
  backButtonWrapper: {
    display: 'block',
    ...mixins.margin(0, 0, 24),
  },
  ctaWrapper: {
    ...mixins.margin(24, 0),
  },
  button: {
    ...fonts.UntitledSans,
    fontWeight: fonts.weight.medium,
  },
};
